export const searchFormColumns = (ctx) => {
  return [
    {
      name: '公司',
      prop: 'warehousingCompanyCode',
      type: 'select',
      options: ctx.companyList,
      changeMethod: 'changeMethod',
    },
    {
      name: '部门',
      prop: 'operationDepartmentCode',
      type: 'select',
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      options: ctx.departmentList,
    },
    {
      prop: 'projectName',
      name: '项目名称',
      type: 'searchTableSpec',
      searchType: 'projectInitiation',
      currentValue: ctx.query.projectName,
      extraData: {
        // projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        // applyDepartmentNoList: ctx.query.departmentCode
        //   ? [ctx.query.departmentCode]
        //   : (ctx.userInfo.allDepartmentList || []).map((v) => v.personDepartmentCode),
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        // applyCompanyNo: ctx.query.warehousingCompanyCode,
        // applyDepartmentNo: ctx.query.operationDepartmentCode,
        // platformtCompany: ctx.query.warehousingCompanyCode,
        // recyclingtCompany: ctx.query.warehousingCompanyCode,
        // applyDepartmentName: ctx.query.operationDepartment,

        // applyCompanyName: ctx.query.warehousingCompany
        //   ? ctx.query.warehousingCompany
        //   : ctx.userInfo.companyName,
        // platformtCompanyName: ctx.query.warehousingCompany
        //   ? ctx.query.warehousingCompany
        //   : ctx.userInfo.companyName,
        // recyclingtCompanyName: ctx.query.warehousingCompany
        //   ? ctx.query.warehousingCompany
        //   : ctx.userInfo.companyName,
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '操作时间',
      prop: 'operationTime',
      type: 'date',
    },
    {
      name: '制单人',
      prop: 'documenter',
      type: 'input',
    },
    {
      name: '文件描述',
      prop: 'fileDescription',
      type: 'input',
    },
  ];
};
export const baseColumnListDefault = [
  {
    field: 'uniqueIdentificationNumber',
    title: '唯一识别号',
    width: 120,
  },
  {
    field: 'warehousingCompany',
    title: '入库公司',
    width: 180,
  },
  {
    field: 'operationDepartment',
    title: '操作部门',
    width: 120,
  },
  {
    field: 'projectNumber',
    title: '项目编号',
    width: 120,
  },
  {
    field: 'projectName',
    title: '项目简称',
    width: 120,
  },
  {
    field: 'documenter',
    title: '制单人',
    width: 100,
  },
  {
    field: 'operationTime',
    title: '操作时间',
    width: 140,
  },
  {
    field: 'fileLink',
    title: '文件链接',
    width: 80,
  },
  {
    field: 'kingdeeState',
    title: '发送金蝶状态',
    width: 120,
  },
  {
    field: 'kingdeeTime',
    title: '发送金蝶时间',
    width: 160,
  },
  {
    field: 'dataState',
    title: '数据状态',
    width: 120,
  },
  {
    field: 'matchingFailFile',
    title: '未成功匹配联行号的文件',
    width: 160,
  },
  {
    field: 'fileDescription',
    title: '文件描述',
    width: 240,
  },
];
